<template>
  <div class="additional-page" v-if="page">
    <b-field>
      <b-input v-model="pageObject.title" @change="handleUpdate" placeholder="Заголовок"/>
    </b-field>
    <b-field>
      <b-input v-model="pageObject.url" @change="handleUpdate" placeholder="Ссылка"/>
    </b-field>
    <Editor
    :editorToolbar="customToolbar"
    placeholder="Текст информации"
    v-model="text"/>
    <p class="slug-url">
      <strong>Ссылка на страницу: </strong> <br>
      <a :href=pageUrl target="_blank">{{pageUrl}}</a>
    </p>
    <div class="save-content-button centered">
      <div class="button save-content" @click="saveAdditionalPage(pageObject)">СОХРАНИТЬ</div>
    </div>
    <div class="columns bottom-container">
      <div class="column delete-service is-one-third" @click="deleteAdditionalPage(page.id)" v-if="!page.isNew">
        <span>Удалить</span>
      </div>
      <div class="column hide">
        <b-switch v-model='pageObject.isHidden' @change="handleUpdate">Скрыть страницу</b-switch>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { VueEditor as Editor } from 'vue2-editor'
import deepcopy from 'deepcopy'
import router from '../../router'

export default {
  name: 'AdditionalPage',
  data () {
    return {
      updateTimer: null,
      text: '',
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['link', 'image'],
        [{ 'align': [] }]
      ]
    }
  },
  computed: {
    ...mapState(['page']),
    pageObject () {
      if (this.page) {
        this.text = this.page.text
        if (!this.page.isNew && this.$route.params.id === 'new') {
          router.push({ name: 'AdditionalPages' })
        }
        return deepcopy(this.page)
      }
    },
    pageUrl () {
      const baseURL = process.env.NODE_ENV === 'production' ? 'grottbjorn.com' : 'grottbjorn.yellow.jetstyle.ru'
      return `https://${baseURL}/additional/${encodeURIComponent(this.pageObject.url)}`
    }
  },
  methods: {
    ...mapActions(['updateAdditionalPage', 'deleteAdditionalPage', 'saveAdditionalPage']),
    handleUpdate () {
      this.pageObject.text = this.text
      this.updateAdditionalPage(this.pageObject)
    }
  },
  components: { Editor },
  watch: {
    text () {
      this.handleUpdate()
    }
  }
}
</script>
<style scoped>
.additional-page {
  max-width: 740px;
  width: 100%;
  margin: 45px auto;
}
.bottom-container {
  margin: 20px 0;
}
.save-content {
  margin: 20px 0 0;
}
.slug-url {
  margin: 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// AdditionalPage.vue?90d5abf2